// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-selection {
  min-height: 100vh;
  background-color: #f5f7fa;
}

/* Header */
.header {
  background-color: white;
  border-bottom: 1px solid #e2e8f0;
  padding: 1.5rem 3rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.logo {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1a202c;
  letter-spacing: -0.025em;
}

.user-menu {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  position: relative;
}

.user-avatar {
  width: 44px;
  height: 44px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 1.1rem;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.user-dropdown {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.75rem;
}

.user-dropdown span {
  font-size: 0.95rem;
  color: #64748b;
  font-weight: 500;
}

.user-dropdown button {
  background: none;
  border: 1.5px solid #e2e8f0;
  padding: 0.625rem 1.25rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  color: #475569;
  transition: all 0.2s ease;
}

.user-dropdown button:hover {
  background-color: #f8fafc;
  border-color: #3b82f6;
  color: #3b82f6;
  transform: translateY(-1px);
}

/* Main Content */
.main-content {
  padding: 3rem;
  max-width: 1600px;
  margin: 0 auto;
}

/* Page Header */
.page-header {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 3rem;
  position: relative;
}

.page-header h1 {
  color: #1a202c;
  font-size: 2.5rem;
  font-weight: 600;
  margin: 0;
  text-align: center;
  letter-spacing: -0.025em;
}

.new-project-btn {
  position: absolute;
  right: 0;
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  color: white;
  border: none;
  padding: 0.875rem 2rem;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);
}

.new-project-btn:hover {
  background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);
}

/* Search and Filters */
.search-filters {
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-bottom: 3rem;
  align-items: center;
}

.search-box {
  position: relative;
  width: 400px;
}

.search-box svg {
  position: absolute;
  left: 1.25rem;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  z-index: 1;
}

.search-box input {
  width: 100%;
  padding: 1rem 1.25rem 1rem 3.5rem;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  font-size: 1rem;
  background-color: white;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.search-box input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1), 0 4px 12px rgba(0, 0, 0, 0.1);
}

.search-box input::placeholder {
  color: #94a3b8;
}

.date-filter {
  position: relative;
  display: flex;
  align-items: center;
}

.date-filter svg {
  position: absolute;
  left: 1.25rem;
  color: #94a3b8;
  z-index: 1;
}

.date-filter input {
  padding: 1rem 1.25rem 1rem 3.5rem;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  font-size: 1rem;
  background-color: white;
  min-width: 200px;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.date-filter input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1), 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* New Project Form */
.new-project-form {
  background-color: white;
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.new-project-form h3 {
  margin: 0 0 1.5rem 0;
  color: #1a202c;
  font-size: 1.25rem;
  font-weight: 600;
}

.new-project-form input {
  width: 100%;
  padding: 1rem 1.25rem;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  font-size: 1rem;
  margin-bottom: 1.5rem;
  transition: all 0.2s ease;
}

.new-project-form input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.form-actions {
  display: flex;
  gap: 1rem;
}

.form-actions button {
  padding: 0.875rem 1.75rem;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.form-actions button[type="submit"] {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  color: white;
  border: none;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);
}

.form-actions button[type="submit"]:hover:not(:disabled) {
  background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);
}

.form-actions button[type="submit"]:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.form-actions button[type="button"] {
  background-color: #f8fafc;
  color: #64748b;
  border: 1.5px solid #e2e8f0;
}

.form-actions button[type="button"]:hover {
  background-color: #f1f5f9;
  border-color: #cbd5e1;
  transform: translateY(-1px);
}

/* Projects Table */
.projects-table {
  background-color: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid #f1f5f9;
}

.table-header {
  display: grid;
  grid-template-columns: 1fr 200px 150px;
  gap: 2rem;
  padding: 1.5rem 2rem;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 1px solid #e2e8f0;
  font-weight: 600;
  color: #374151;
  align-items: center;
  font-size: 0.95rem;
}

.table-row {
  display: grid;
  grid-template-columns: 1fr 200px 150px;
  gap: 2rem;
  padding: 1.5rem 2rem;
  border-bottom: 1px solid #f8fafc;
  transition: all 0.2s ease;
  align-items: center;
}

.table-row:hover {
  background: linear-gradient(135deg, #fefffe 0%, #f8fafc 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.table-row:last-child {
  border-bottom: none;
}

.project-name {
  color: #3b82f6;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 1rem;
}

.project-name:hover {
  color: #1d4ed8;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.project-date {
  color: #64748b;
  font-size: 0.95rem;
  font-weight: 500;
  text-align: center;
}

.project-actions {
  display: flex;
  gap: 0.75rem;
  justify-content: center;
}

.project-actions button {
  background-color: white;
  border: 1.5px solid #e2e8f0;
  padding: 0.625rem;
  border-radius: 6px;
  cursor: pointer;
  color: #64748b;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
}

.project-actions button:hover {
  background-color: #f8fafc;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.project-actions button.chat-action:hover {
  border-color: #1976d2;
  color: #1976d2;
  background-color: #e3f2fd;
}

.project-actions button:nth-child(2):hover {
  border-color: #059669;
  color: #059669;
  background-color: #ecfdf5;
}

.project-actions button:last-child:hover {
  border-color: #dc2626;
  color: #dc2626;
  background-color: #fef2f2;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 4rem 2rem;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid #f1f5f9;
}

.empty-state h3 {
  color: #374151;
  margin-bottom: 0.75rem;
  font-size: 1.25rem;
  font-weight: 600;
}

.empty-state p {
  color: #64748b;
  margin: 0;
  font-size: 1rem;
}

/* Responsive */
@media (max-width: 1024px) {
  .header {
    padding: 1.5rem 2rem;
  }

  .main-content {
    padding: 2rem;
  }

  .page-header {
    flex-direction: column;
    gap: 1.5rem;
    align-items: center;
  }

  .page-header h1 {
    font-size: 2rem;
  }

  .new-project-btn {
    position: relative;
    right: auto;
  }

  .search-filters {
    flex-direction: column;
    gap: 1rem;
  }

  .search-box {
    width: 100%;
    max-width: 400px;
  }
}

@media (max-width: 768px) {
  .table-header,
  .table-row {
    grid-template-columns: 1fr;
    gap: 1rem;
    text-align: center;
  }

  .project-actions {
    justify-content: center;
  }

  .main-content {
    padding: 1rem;
  }

  .header {
    padding: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ProjectSelection.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,uBAAuB;EACvB,gCAAgC;EAChC,oBAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4EAA4E;AAC9E;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4EAA4E;AAC9E;;AAEA,qBAAqB;AACrB;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA,mBAAmB;AACnB;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,oBAAoB;EACpB,6DAA6D;EAC7D,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,oBAAoB;EACpB,gCAAgC;EAChC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;AACjB;;AAEA,eAAe;AACf;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE;;IAEE,0BAA0B;IAC1B,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".project-selection {\n  min-height: 100vh;\n  background-color: #f5f7fa;\n}\n\n/* Header */\n.header {\n  background-color: white;\n  border-bottom: 1px solid #e2e8f0;\n  padding: 1.5rem 3rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.logo {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: #1a202c;\n  letter-spacing: -0.025em;\n}\n\n.user-menu {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n  position: relative;\n}\n\n.user-avatar {\n  width: 44px;\n  height: 44px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 1.1rem;\n  cursor: pointer;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n\n.user-dropdown {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 0.75rem;\n}\n\n.user-dropdown span {\n  font-size: 0.95rem;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.user-dropdown button {\n  background: none;\n  border: 1.5px solid #e2e8f0;\n  padding: 0.625rem 1.25rem;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: #475569;\n  transition: all 0.2s ease;\n}\n\n.user-dropdown button:hover {\n  background-color: #f8fafc;\n  border-color: #3b82f6;\n  color: #3b82f6;\n  transform: translateY(-1px);\n}\n\n/* Main Content */\n.main-content {\n  padding: 3rem;\n  max-width: 1600px;\n  margin: 0 auto;\n}\n\n/* Page Header */\n.page-header {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 3rem;\n  position: relative;\n}\n\n.page-header h1 {\n  color: #1a202c;\n  font-size: 2.5rem;\n  font-weight: 600;\n  margin: 0;\n  text-align: center;\n  letter-spacing: -0.025em;\n}\n\n.new-project-btn {\n  position: absolute;\n  right: 0;\n  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);\n  color: white;\n  border: none;\n  padding: 0.875rem 2rem;\n  border-radius: 8px;\n  font-weight: 600;\n  font-size: 0.95rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);\n}\n\n.new-project-btn:hover {\n  background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);\n}\n\n/* Search and Filters */\n.search-filters {\n  display: flex;\n  justify-content: center;\n  gap: 2rem;\n  margin-bottom: 3rem;\n  align-items: center;\n}\n\n.search-box {\n  position: relative;\n  width: 400px;\n}\n\n.search-box svg {\n  position: absolute;\n  left: 1.25rem;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #94a3b8;\n  z-index: 1;\n}\n\n.search-box input {\n  width: 100%;\n  padding: 1rem 1.25rem 1rem 3.5rem;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 10px;\n  font-size: 1rem;\n  background-color: white;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.search-box input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1), 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.search-box input::placeholder {\n  color: #94a3b8;\n}\n\n.date-filter {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.date-filter svg {\n  position: absolute;\n  left: 1.25rem;\n  color: #94a3b8;\n  z-index: 1;\n}\n\n.date-filter input {\n  padding: 1rem 1.25rem 1rem 3.5rem;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 10px;\n  font-size: 1rem;\n  background-color: white;\n  min-width: 200px;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.date-filter input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1), 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n/* New Project Form */\n.new-project-form {\n  background-color: white;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 2rem;\n  margin-bottom: 2rem;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.new-project-form h3 {\n  margin: 0 0 1.5rem 0;\n  color: #1a202c;\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n.new-project-form input {\n  width: 100%;\n  padding: 1rem 1.25rem;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 1rem;\n  margin-bottom: 1.5rem;\n  transition: all 0.2s ease;\n}\n\n.new-project-form input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.form-actions {\n  display: flex;\n  gap: 1rem;\n}\n\n.form-actions button {\n  padding: 0.875rem 1.75rem;\n  border-radius: 8px;\n  font-weight: 600;\n  font-size: 0.95rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.form-actions button[type=\"submit\"] {\n  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);\n  color: white;\n  border: none;\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);\n}\n\n.form-actions button[type=\"submit\"]:hover:not(:disabled) {\n  background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);\n}\n\n.form-actions button[type=\"submit\"]:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.form-actions button[type=\"button\"] {\n  background-color: #f8fafc;\n  color: #64748b;\n  border: 1.5px solid #e2e8f0;\n}\n\n.form-actions button[type=\"button\"]:hover {\n  background-color: #f1f5f9;\n  border-color: #cbd5e1;\n  transform: translateY(-1px);\n}\n\n/* Projects Table */\n.projects-table {\n  background-color: white;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  border: 1px solid #f1f5f9;\n}\n\n.table-header {\n  display: grid;\n  grid-template-columns: 1fr 200px 150px;\n  gap: 2rem;\n  padding: 1.5rem 2rem;\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  border-bottom: 1px solid #e2e8f0;\n  font-weight: 600;\n  color: #374151;\n  align-items: center;\n  font-size: 0.95rem;\n}\n\n.table-row {\n  display: grid;\n  grid-template-columns: 1fr 200px 150px;\n  gap: 2rem;\n  padding: 1.5rem 2rem;\n  border-bottom: 1px solid #f8fafc;\n  transition: all 0.2s ease;\n  align-items: center;\n}\n\n.table-row:hover {\n  background: linear-gradient(135deg, #fefffe 0%, #f8fafc 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.table-row:last-child {\n  border-bottom: none;\n}\n\n.project-name {\n  color: #3b82f6;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 1rem;\n}\n\n.project-name:hover {\n  color: #1d4ed8;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\n.project-date {\n  color: #64748b;\n  font-size: 0.95rem;\n  font-weight: 500;\n  text-align: center;\n}\n\n.project-actions {\n  display: flex;\n  gap: 0.75rem;\n  justify-content: center;\n}\n\n.project-actions button {\n  background-color: white;\n  border: 1.5px solid #e2e8f0;\n  padding: 0.625rem;\n  border-radius: 6px;\n  cursor: pointer;\n  color: #64748b;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n}\n\n.project-actions button:hover {\n  background-color: #f8fafc;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.project-actions button.chat-action:hover {\n  border-color: #1976d2;\n  color: #1976d2;\n  background-color: #e3f2fd;\n}\n\n.project-actions button:nth-child(2):hover {\n  border-color: #059669;\n  color: #059669;\n  background-color: #ecfdf5;\n}\n\n.project-actions button:last-child:hover {\n  border-color: #dc2626;\n  color: #dc2626;\n  background-color: #fef2f2;\n}\n\n/* Empty State */\n.empty-state {\n  text-align: center;\n  padding: 4rem 2rem;\n  background-color: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  border: 1px solid #f1f5f9;\n}\n\n.empty-state h3 {\n  color: #374151;\n  margin-bottom: 0.75rem;\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n.empty-state p {\n  color: #64748b;\n  margin: 0;\n  font-size: 1rem;\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .header {\n    padding: 1.5rem 2rem;\n  }\n\n  .main-content {\n    padding: 2rem;\n  }\n\n  .page-header {\n    flex-direction: column;\n    gap: 1.5rem;\n    align-items: center;\n  }\n\n  .page-header h1 {\n    font-size: 2rem;\n  }\n\n  .new-project-btn {\n    position: relative;\n    right: auto;\n  }\n\n  .search-filters {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .search-box {\n    width: 100%;\n    max-width: 400px;\n  }\n}\n\n@media (max-width: 768px) {\n  .table-header,\n  .table-row {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n    text-align: center;\n  }\n\n  .project-actions {\n    justify-content: center;\n  }\n\n  .main-content {\n    padding: 1rem;\n  }\n\n  .header {\n    padding: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
